import { t } from 'ttag'

import { Trash2Icon } from 'components/shared/Icon/model'

const DELETE = 'DELETE'

export const ACTIONS = { DELETE }

export const getActions = () => [
  { icon: Trash2Icon, label: t`Remove`, type: DELETE },
]

export const getOutcomeScoreLabels = () => [t`low`, t`moderate`, t`high`]
